import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './WatchlistEmptyState.style';

function WatchlistEmptyState({tt = withTranslation.ttDefaultProp}: any) {
  return (
    <View style={styles.container}>
      <Icon name="starUnfilled" style={styles.starIcon} />
      <Text
        emphasis="high"
        variant="xLarge"
        style={[styles.title, styles.titlePaddingBottom]}>
        {tt('title', 'Your Watchlist is empty')}
      </Text>
      <Text
        emphasis="high"
        variant="small"
        style={[styles.description, styles.descriptionPaddingBottom]}
        isBold>
        {tt('subtitle', 'Want to keep an eye on certain coaches?')}
      </Text>

      <Text emphasis="high" variant="small" style={styles.description} isBold>
        {tt(
          'subtitle',
          'Tap the star icon next to any coach to add them here for quick access.',
        )}
      </Text>

      <View style={styles.previewBox}>
        <Text style={styles.previewLabel} isBold>
          Preview
        </Text>
        <View style={styles.previewItem}>
          <View style={styles.avatarPlaceholder} />
          <View style={styles.textContainer}>
            <Text style={styles.coachName} isBold>
              Coach Name
            </Text>
            <Text style={styles.coachRank}>Coach Rank</Text>
          </View>
          <Icon name="starUnfilled" style={styles.UnwishList} />
        </View>
      </View>
    </View>
  );
}

export default withTranslation('report.watchlistEmptyState')(
  WatchlistEmptyState,
);
